import { handleExternalLinks } from '../helpers';

const toggleBtn = document.querySelector('.offcanvas-toggler');
const closeIcon = toggleBtn.querySelector('.close-button');
const openIcon = toggleBtn.querySelector('.open-button');
const offCanvas = document.querySelector('.offcanvas');
const topLevelItems = document.querySelectorAll('.offcanvas-top-level-menu > ul > li > a');
const backBtns = document.querySelectorAll('.offcanvas-submenu-back');
let opened = false;

topLevelItems.forEach((item, i) => {
	const subMenu = item.closest('li').querySelector('.offcanvas-submenu');

	if (subMenu) {
		item.addEventListener('click', (e) => {
			e.preventDefault();
			setActiveItem(i);
		});
	}
});

if (toggleBtn) {
	toggleBtn.addEventListener('click', () => {
		(opened ? close : open)();
	});
}

backBtns.forEach((backBtn) => {
	backBtn.addEventListener('click', () => setActiveItem(-1));
	backBtn.addEventListener('keydown', (e) => {
		if (e.keyCode === 'Enter') setActiveItem(-1);
	});
});

function setActiveItem(i) {
	topLevelItems.forEach((item, j) => {
		if (i === j) {
			item.closest('li')?.classList.add('active');
		} else {
			item.closest('li')?.classList.remove('active');
		}
	});
}

function close() {
	offCanvas.setAttribute('inert', '');
	if (closeIcon && openIcon) {
		closeIcon.classList.add('opacity-0');
		closeIcon.classList.add('scale-25');
		openIcon.classList.remove('opacity-0');
		openIcon.classList.remove('scale-25');
	}
	if (offCanvas) {
		offCanvas.classList.remove('active');
	}
	opened = false;

	// Wait for the transition to finish, otherwise we'll get a weird effect.
	setTimeout(() => {
		setActiveItem(-1);
	}, 500);
}

function open() {
	offCanvas.removeAttribute('inert');
	if (closeIcon && openIcon) {
		closeIcon.classList.remove('opacity-0');
		closeIcon.classList.remove('scale-25');
		openIcon.classList.add('opacity-0');
		openIcon.classList.add('scale-25');
	}
	if (offCanvas) {
		offCanvas.classList.add('active');
	}
	opened = true;
}
